import { render, staticRenderFns } from "./ReopenQuerylogsForm.vue?vue&type=template&id=021484c6&"
import script from "./ReopenQuerylogsForm.vue?vue&type=script&lang=js&"
export * from "./ReopenQuerylogsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports